import React, { useEffect, useState, useRef } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
// import { getUserById, UpdateUser } from "../../api/api";
import { getUserById, UpdateUser } from "../api/api";
import "../UserProfileEdit/EditCultureReligion.css";
import bgImage from "../../assets/images/brown-background.jpg";

const EditCultureReligion = () => {
  const navigate = useNavigate();
  const religious_belief = useRef(null);
  const cultural_background = useRef(null);
  const [userdata, setUserdata] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    religious_belief: Yup.string().required("Please answer this question"),
    cultural_background: Yup.string().required("Please answer this question"),
  });

  useEffect(() => {
    const getUserData = async () => {
      try {
        const storedUser = JSON.parse(localStorage.getItem("currentUser"));
        const _id = storedUser?.id || storedUser?._id;

        if (_id) {
          const response = await getUserById({ user_id: _id });
          setUserdata(response?.data || {});
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        navigate("/login");
      }
    };

    getUserData();
  }, [navigate]);

  const handleSubmit = async (values) => {
    setIsLoading(true);
    try {
      const storedUser = JSON.parse(localStorage.getItem("currentUser"));
      const _id = storedUser?.id || storedUser?._id;

      const payload = {
        user_id: _id,
        cultural_background: values.cultural_background,
        religious_belief: values.religious_belief,
      };

      const response = await UpdateUser(payload);

      if (response?.success) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response?.message,
        }).then(() => navigate("/Sidebar/EditProfile"));
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response?.message || "Update failed",
        });
      }
    } catch (error) {
      console.error("Update error:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="update-container"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <h2 className="cultureform-heading">Update Your Cultural and Religion</h2>

      <Formik
        enableReinitialize
        initialValues={{
          religious_belief: userdata?.religious_belief || "",
          cultural_background: userdata?.cultural_background || "",
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          values,
          errors,
          touched,
        }) => (
          <form onSubmit={handleSubmit} className="form">
            <div className="form-group">
              <label>What is your religious belief?</label>
              <textarea
                ref={religious_belief}
                placeholder="Please answer in religious belief"
                onChange={handleChange("religious_belief")}
                onBlur={handleBlur("religious_belief")}
                value={values.religious_belief}
                rows={6}
              />
              {touched.religious_belief && errors.religious_belief && (
                <span className="error">{errors.religious_belief}</span>
              )}
            </div>

            <div className="form-group">
              <label>What is your cultural background?</label>
              <textarea
                ref={cultural_background}
                placeholder="Please answer in cultural background"
                onChange={handleChange("cultural_background")}
                onBlur={handleBlur("cultural_background")}
                value={values.cultural_background}
                rows={6}
              />
              {touched.cultural_background && errors.cultural_background && (
                <span className="error">{errors.cultural_background}</span>
              )}
            </div>

            <div className="button-group">
              <button
                type="button"
                className="btn cancel-btn"
                onClick={() => navigate("/Sidebar/EditProfile")}
                // .then(() => navigate("/Sidebar/EditProfile"))
              >
                Back
              </button>
              <button
                type="submit"
                className="btn update-btn"
                disabled={isLoading}
              >
                {isLoading ? "Updating..." : "Update"}
              </button>
            </div>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default EditCultureReligion;
